import * as React from 'react';
import { useEffect, useState } from 'react';
import Modal from '@mui/material/Modal';
import { useForm, SubmitHandler } from 'react-hook-form';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { useCookies } from 'react-cookie';
import baseUrlApi from '../../lib/baseUrlApi';
import sensorKindConsts from "../../Consts/SensorKinds";
import Utility from "../../Consts/Utility";
import Rules from "../../Consts/Rules";
import {ApiRequest} from "../../Consts/ApiRequest";
import { modalProps } from '../../Consts/constants';

type SensorAdminInputs = {
  sensorID: string;
  sensorName: string
  sensorKind: string;
};

interface SensorAdminProps {
  data: SensorAdminInputs[];
}

interface SensorProps {
  setState: Function;
}

export default function SensorCreateModa(props: SensorProps) {
  const [open, setOpen] = React.useState(false);
  const [SensorAdminData, setSensorAdminData] = useState<SensorAdminInputs[]>([]);
  const [sensorID, setSensorID] = useState<string>("");
  const [sensorName, setSensorName] = useState<string>("");
  const [sensorKind, setSensorKind] = useState<number>(0);
  const [error, setError] = useState<string[]>([]);
  const {register: register, reset: reset, handleSubmit: handleSubmit,formState: { errors: errors } } = useForm<SensorAdminInputs>({
    defaultValues: {
      sensorID: "",
      sensorName: "",
      sensorKind: "",
    }
  });

  const resetData = async () => {
    setSensorAdminData([]);
    setSensorID("")
    setSensorName("")
    setSensorKind(0)
    setError([]);
    reset();
  }
  const handleOpen = async() => {
    resetData();
    setOpen(true);
  }
  const handleClose = async() => {
    resetData();
    setOpen(false);
  }

  const rules1 = {
    required: '入力してください',
    maxLength: {
      value: 100,
      message: "100文字以内で入力してください"
    },
  }
  const rules2 = {
    maxLength: {
      value: 60,
      message: ""
    },
  }
  const rules3 = {
    required: '入力してください',
  }

  const navigate = useNavigate();
  // クッキーに保存されたトークンを定数に格納
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);

  const  handleOpenWrapper = function() {
    handleOpen();
  }

  const  handleCloseWrapper = function() {
    handleClose();
  }

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }


  useEffect(() => {
    Utility.isEmpty(errors)
  });

  const onSubmit: SubmitHandler<SensorAdminInputs> = async (data) => {
    try {
        const token = cookies.access_token || "";
        let params = {
            "prcKind": 0,
            "sensorInfo": {
                "sensorID": sensorID,
                "sensorName": sensorName,
                "sensorKind": Number(sensorKind),
            },
        };
        await ApiRequest.registSensor(params, token, (response: any) => {
            setError(response.data.messsages);
            console.log(response);
            if (Array.isArray(response.data)) {
                setSensorAdminData(response.data);
            }
            if (response.data.result === 0) {
                handleCloseWrapper();
            }
            props.setState(" ")
        }, (error: any) => {
            errorCallback(error);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      alert("エラーが発生しました");
    }
  };

  return (
    <div>
      <button onClick={handleOpenWrapper} className="btn btn-blue"><i className="icon-add-w"></i>センサ追加</button>
      <Modal {...modalProps} open={open}>
        <div className="modal-wrapper" style={{ display: "flex" }} id="modal-message">
          <div className="modal">
            <div className="modal-header">
              <div className="modal-title">
                センサ情報追加
              </div>
              <a onClick={handleCloseWrapper} className="modal-close"></a>
            </div>
            <div className="modal-body">
              <div className="edit-box">
                <div className="edit-box-elm">
                  {
                    (error.length > 0 || !Utility.isEmpty(errors)) ?
                      <ul className="error-box">
                          {error.map((item, index) => (
                              <li>{item}</li>
                          ))}
                          {errors.sensorID && <li>センサ管理番号は100文字以下の半角英数字及びハイフンで入力してください。</li>}
                          {errors.sensorKind && <li>センサ種別を選択してください。</li>}
                      </ul>
                      : null
                  }
                  <div className="edit-box-elm-name">センサ管理番号<span className="required"></span></div>
                  <div className="edit-box-elm-input">
                    <input
                      type="text"
                      defaultValue={sensorID}
                      placeholder="sensorID"
                      // WARNING:バリデーションルールが適用されてません
                      onChange={(e) => setSensorID(e.target.value)}
                      className={"col-320 "}
                    />
                  </div>
                </div>
                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">センサ名</div>
                  <div className="edit-box-elm-input">
                    <input
                      type="text"
                      defaultValue={sensorName}
                      placeholder="sensorName"
                      // WARNING:バリデーションルールが適用されてません
                      onChange={(e) => setSensorName(e.target.value)}
                      className={"col-320 "}
                    />
                  </div>
                </div>
                <div className="edit-box-elm">
                  <div className="edit-box-elm-name">センサ種別<span className="required"></span></div>
                  <div className="edit-box-elm-input">
                    <select
                        defaultValue={sensorKind}
                        // WARNING:バリデーションルールが適用されてません
                        onChange={(e) => setSensorKind(Number(e.target.value))}
                        className={"col-320 "}
                    >
                      <option value="" key={""}>-</option>
                      {sensorKindConsts.kinds.map((item, index) => (
                          <option value={item.index} key={item.index}>{item.name}</option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <div className="model-action-sub">
              </div>
              <div className="model-action-main">
                <button className="btn btn-blue-line">
                  <a onClick={handleCloseWrapper} className="">
                    キャンセル
                  </a>
                </button>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <button className="btn btn-blue col-160">
                    <i className="icon-check-w"></i>確定
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
}
